//添加用户
const addUser = '/user/addUser'

//获取用户信息
const getUser = '/user/getUser/{userNo}'

const getUserList = '/user/getUserList'

const addSubUser = '/user/addSubUser'

//登录
const userLogin = '/user/login'

//登出
const userLogout = '/user/logout'

//获取上传文件列表
const listUploadList = '/data/listUploadList/{pageNum}/{pageSize}/{parentId}'

//上传文件
const uploadData = '/data/uploadData'

//更新备注
const updateRemark = '/data/updateRemark/{resId}'

//获取子文件列表
const listSubFile = '/data/listSubFile/{pageNum}/{pageSize}'

//获取用户所有的角色
const listRole4CurrentUser = '/user/listRole4CurrentUser'


//查询识别结果
const getRecoResult = '/data/getRecoResult4Common/{billNo}'

//删除文件
const delFile = '/data/delFile/{resId}'

//删除文件-批量
const delFileBatch = '/data/delFileBatch'

//websocket
const websocket = '/websocket/{resId}'

//图片翻页
const rollPage = '/data/rollPage/{pId}/{resId}/{rollFlag}'

//手工处理
const listFailedFile = '/data/listFailedFile/{pageNum}/{pageSize}'

//获取证件类型列表
const listAllCertiType = '/rule/listAllCategory'

//更新证件类型-人工处理
const updateCeriType = '/data/updateCeriType'

//编辑
const updateRecoResult = '/data/updateRecoResult'

// 自动识别回流纠错
const dataAutoReco = '/data/autoReco'

//更新证件类型
const updateCertiType4Success = '/data/updateCertiType4Success/{resId}/{category}'

//发送邮件
const sendMail = '/mail/sendMail'

//图片上传
const uploadPicture = '/mail/uploadPicture'

//选中验证
const selectCertificate = '/certificate/selectCertificate'

//更新客户信息
const updateCustomerInfo = '/data/updateCustomerInfo/{resId}'

//开始校验
const startCheck = '/certificate/startCheck'

//更改单证备注
const updateCertiRemark = '/certificate/updateCertiRemark/{certiId}'

//再次校验
const recheck = '/certificate/recheck/{id}'

//更改单证审核标志
const updateReviewFlag = '/certificate/updateReviewFlag/{resId}'

//获取单证校验记录
const listCheckRecords = '/certificate/listCheckRecords/{pageNum}/{pageSize}'

//删除校验历史
const delCheckRecord = '/certificate/delCheckRecord/{recordId}'

//获取字段下载记录
const listDownloadRecords = '/certificate/listDownloadRecords/{pageNum}/{pageSize}'

//导出单证字段
const exportFields = '/certificate/exportFields/{recordId}'

//导出单证文件
const exportCertiFile = '/certificate/exportCertiFile'

//导出单证Excel  
const exportExcelCertiFile = '/certificate/exportExcelCertiFile'

//获取选择单证的图片信息
const getCertiImageInfo = '/certificate/getCertiImageInfo/{recordId}'

//更换单证
const changeCertificate = '/certificate/changeCertificate'

//更改单证标记
const updateCertiReviewFlag = '/certificate/updateCertiReviewFlag/{certiId}'

//更改单证校验记录标识
const updateCertiFlag = '/certificate/updateCertiFlag/{certiId}/{flagType}'

//图片数 人数
const taskStatus = '/taskStatus'

// 获取官网用户信息
const getCurrentUser = '/user/getCurrentUser'

//查询分配的单证类型
const listAllocateCategory = '/config/listAllocateCategory/{userNo}/{pageNo}/{pageSize}'

// 图像分类识别的接口（分类失败，手动识别的接口）
const picRecognition = '/v3/custom_api/picRecognition'

//图片旋转的角度
const rotateImage = 'data/rotateImage/{resId}/{angle}'

// 单证类型
const dataListAllCertiType = '/data/listAllCertiType'


//查询模板
const listRuleTemplate = '/rule/listRuleTemplate/{pageNum}/{pageSize}/{templateType}'

//搜索提示
const searchHelp = '/rule/searchHelp'

//复制模板
const copyTemplate = '/rule/copyTemplate/{id}'

// 模板分享
const copyShareTemplate = '/claim/copyShareTemplate/{id}'

//获取模板信息
const getTemplateInfo = '/rule/getTemplateInfo/{id}'

//根据分类ID查询字段
const listTemplateCategoryRelation = '/rule/listTemplateCategoryRelation/{categoryId}'

const setTemplateDictType = '/rule/setTemplateDictType/{categoryId}'

//保存分组配置
const setGroup4Template = '/rule/setGroup4Template/{templateId}'

//模板配置-更换单证
const replaceCertiFile = '/data/replaceCertiFile'

//删除模板
const deleteTemplate = '/rule/deleteTemplate/{id}'

//删除字段
const deleteField = '/rule/deleteField/{templateId}/{fieldName}'

//获取规则映射
const getRuleMapName = '/rule/getRuleMapName'

//编辑模板
const editTemplate = '/rule/editTemplate/{templateId}'

//模板关联单证和规则
const updateTemplate = '/rule/updateTemplate'

//设置模板规则
const setSubType4Template = '/rule/setSubType4Template/{templateId}'

//测试规则
const testRule = '/rule/testRule'

//测试模板
const testTemplate = '/rule/testTemplate/{templateId}'

//获取字段列表
const listFieldByType = '/rule/listFieldByType/{category}'

//获取OCR识别结果
const getOcrOriginData = '/rule/getOcrOriginData'

//提交审核
const submit2Review = '/rule/submit2Review/{id}'

//测试正则表达式是否正确
const testRegex = '/rule/testRegex'

//获取模板图片信息
const getTemplateImage = '/data/getTemplateImage/{id}'


//模板配置上传文件
const uploadFile = '/uploadFile'

//获取数据集列表
const getListDataset = '/dataset/listDataset/{pageNum}/{pageSize}'

//删除数据集
const delDataset = '/dataset/delDataset/{id}'

//测试数据集
const testDataset = '/dataset/testDataset/{setId}/{templateId}'

//获取标准数据列表
const listStandardData = '/dataset/listStandardData/{pageNum}/{pageSize}'

//获取子文件列表
// const listSubFile = '/data/listSubFile/{pageNum}/{pageSize}'

//获取证件类型列表
// const listAllCertiType = '/rule/listAllCategory'

//创建数据集
const createDataset = '/dataset/createDataset'

//图片翻页
// const rollPage = '/data/rollPage/{pId}/{resId}/{rollFlag}'

//获取数据集中数据列表
const listStandardDataBySetId = '/dataset/listStandardDataBySetId/{pageNum}/{pageSize}/{setId}'

//从数据集中删除标准数据
const removeDataFromDataset = '/dataset/removeDataFromDataset/{setId}'

//更改数据集名称
const updateDatasetName = '/dataset/updateDatasetName'

//向数据集中添加标准数据
const addData2Dataset = '/dataset/addData2Dataset/{setId}'

//审核模板
const reviewTemplate = '/rule/reviewTemplate'

//发布模板
const publishTemplate = '/rule/publishTemplate/{id}'

//取消发布模板
const revokePublishTemplate = '/rule/revokePublishTemplate/{id}'

//查询驳回原因
const getRejectRemark = '/rule/getRejectRemark/{templateId}'

// 添加模板记录
const addTemplate = '/rule/addTemplate'

// 编辑字段名称
const updateFieldName = '/rule/updateFieldName/{templateId}'

//判断模板关键字是否重复
const checkDuplicateTemplate = '/rule/checkDuplicateTemplate'


//新增单证类型
const addCategory = '/config/addCategory'

//获取单证类型
const listCategory = '/config/listCategory'

// 获取所有子文件
const listSubAllFile = '/data/listSubFile'

//查询单证
const listDityExportFieldsConfig = '/dictionary/listDityExportFieldsConfig'

//保存单证对应导出字段
const setDityExportFieldsConfig = '/dictionary/setDityExportFieldsConfig'

//导出OCR识别结果
const exportOcrOriginData = '/rule/exportOcrOriginData'

// 查询OCR类型
const getUserOcrType = '/user/getUserOcrType'

// 更新OCR类型
const updateUserOcrType = '/user/updateUserOcrType/{type}'

//获取单证类型
const getClassifyRuleInfo = '/config/getClassifyRuleInfo/{caId}'

//编辑单证类型
const editClassifyRule = '/config/editClassifyRule/{ruleId}'

//删除单证类型
const delCategory = '/config/delCategory/{id}'

//新增字段
const addDictType = '/dictionary/addDictType'

//更新字段
const updateDictType = '/dictionary/updateDictType/{id}'

//查询字段
const listDityCategoryRelation = '/dictionary/listDityCategoryRelation/{pageNum}/{pageSize}/?categoryIdOrName={categoryIdOrName}'

//添加字段与单证类型关联
const updateDityCategoryRelation = '/dictionary/updateDityCategoryRelation/{categoryId}'

//新增字段
const listByDityCodeOrName = '/dictionary/listByDityCodeOrName'

//根据分类ID查询字段
const listDityCategoryRelationUsed = '/dictionary/listDityCategoryRelationUsed/{categoryId}'

//删除自定义字段
const removedDictType = '/dictionary/removedDictType/{id}/?dityCode={dityCode}'
//标注图片的回流
const insertCorredErrData = '/data/insertCorredErrData'

const sendShortCode = '/user/sendShortCode'

const registerUserByPhone = '/user/registerUserByPhone'

const loginByPhone = '/user/loginByPhone'

const getCurrentUserInfo = '/user/getCurrentUserInfo/#{userNo}'

const updateCurrentUserInfo = '/user/updateCurrentUserInfo'

const updateCurrentPwdInfo = '/user/updateCurrentPwdInfo'

const getOrgAcctByOrgCode = '/tOrgUserInfo/getOrgAcctByOrgCode'

const tOrgAccountPage = '/goodsInfo/payAmountList/{pageNo}/{limit}'

const updatePwdByOrgPwdInfo = '/user/updatePwdByOrgPwdInfo'

const upgradeToEnterprise = '/manage/addEnterpriseInfo'

const getEnterpriseByOrgCode = '/manage/getEnterpriseInfo/{orgCode}'

const ocrEnterpriceCode = '/api/uploadPayReceipt/{serialNo}'

const tGoodsInfoList = '/goodsInfo/getGoodsInfolist'

const xwBigModelExtract = '/api/xwBigModelExtract?extractFields='

const xwBigModelExtractDy = '/api/xwBigModelExtractDy?extractFields='

const dsAliBigModelExtract = '/api/dsAliBigModelExtract?extractFields='

const createTransferOrders = '/goodsInfo/createPayOrders'

const createOnlinePayOrders = '/goodsInfo/createOnlinePayOrders'

const paymentSuccessful = '/tRechargeOrder/paymentSuccessful'

const tRechargeOrderPage = '/goodsInfo/payOrdersList/{pageNo}/{pageSize}'

const authNoUpdateAllUserInfo = '/user/authNoUpdateAllUserInfo'


const deleteUser = '/user/deleteUser/{userNo}'


const tRechargeOrderCloseOrder = '/goodsInfo/closePayOrders'


const tUsageRecordGetCountByTime = '/manage/getOcrByDay/{time}'


const shareTemplate = '/rule/shareTemplate/{ruleId}/{flag}'

const listShareRuleTemplate = '/rule/listShareTemplate/{pageNo}/{pageSize}'

const listShareCategory = '/rule/listShareCategory'

const getOcrListByDay = '/manage/getOcrListByDay/{pageNo}/{pageSize}/{month}'


const notInvoiceList = '/invoiceInfo/notInvoiceList/{pageNo}/{pageSize}'


const createInvoice = '/invoiceInfo/createInvoice'

const getInvoiceList = '/invoiceInfo/getInvoiceList/{pageNo}/{pageSize}'

const invoiceItemList = '/invoiceInfo/invoiceItemList/{invoNo}/{pageNo}/{pageSize}'

const payOrdersCheck = '/goodsInfo/payOrdersCheck'




//重置标注回显
// const dataAutoReco = '/data/autoReco'


export default {
  payOrdersCheck,
  createOnlinePayOrders,
  invoiceItemList,
  getInvoiceList,
  notInvoiceList,
  createInvoice,
  listShareCategory,
  getOcrListByDay,
  listShareRuleTemplate,
  shareTemplate,
  tUsageRecordGetCountByTime,
  tRechargeOrderCloseOrder,
  deleteUser,
  authNoUpdateAllUserInfo,
  tRechargeOrderPage,
  paymentSuccessful,
  createTransferOrders,
  tGoodsInfoList,
  addSubUser,
  ocrEnterpriceCode,
  getEnterpriseByOrgCode,
  upgradeToEnterprise,
  updatePwdByOrgPwdInfo,
  tOrgAccountPage,
  getOrgAcctByOrgCode,
  updateCurrentPwdInfo,
  updateCurrentUserInfo,
  getCurrentUserInfo,
  getUserList,
  loginByPhone,
  registerUserByPhone,
  addUser,
  getUser,
  listUploadList,
  uploadData,
  updateRemark,
  delFile,
  delFileBatch,
  websocket,
  listFailedFile,
  updateCeriType,
  updateRecoResult,
  updateCertiType4Success,
  sendMail,
  uploadPicture,
  selectCertificate,
  updateCustomerInfo,
  startCheck,
  updateCertiRemark,
  recheck,
  updateReviewFlag,
  listCheckRecords,
  delCheckRecord,
  listDownloadRecords,
  exportFields,
  exportCertiFile,
  exportExcelCertiFile,
  getCertiImageInfo,
  changeCertificate,
  updateCertiReviewFlag,
  updateCertiFlag,
  taskStatus,
  getCurrentUser,
  listAllocateCategory,
  picRecognition,
  rotateImage,
  dataListAllCertiType,
  listSubAllFile,
  listDityExportFieldsConfig,
  setDityExportFieldsConfig,
  exportOcrOriginData,
  getUserOcrType,
  updateUserOcrType,
  userLogin,
  userLogout,
  listRole4CurrentUser,
  getRecoResult,
  listRuleTemplate,
  searchHelp,
  copyTemplate,
  getTemplateInfo,
  replaceCertiFile,
  deleteTemplate,
  deleteField,
  getRuleMapName,
  editTemplate,
  updateTemplate,
  setSubType4Template,
  testRule,
  testTemplate,
  listFieldByType,
  getOcrOriginData,
  submit2Review,
  testRegex,
  getTemplateImage,
  uploadFile,
  setGroup4Template,
  getListDataset,
  delDataset,
  testDataset,
  listStandardData,
  listSubFile,
  listAllCertiType,
  createDataset,
  rollPage,
  listStandardDataBySetId,
  removeDataFromDataset,
  updateDatasetName,
  addData2Dataset,
  reviewTemplate,
  publishTemplate,
  getRejectRemark,
  addTemplate,
  updateFieldName,
  checkDuplicateTemplate,
  addCategory,
  listCategory,
  getClassifyRuleInfo,
  editClassifyRule,
  delCategory,
  addDictType,
  listDityCategoryRelation,
  updateDictType,
  updateDityCategoryRelation,
  listByDityCodeOrName,
  listDityCategoryRelationUsed,
  removedDictType,
  insertCorredErrData,
  dataAutoReco,
  sendShortCode,
  revokePublishTemplate,
  listTemplateCategoryRelation,
  setTemplateDictType,
  copyShareTemplate,
  xwBigModelExtract,
  xwBigModelExtractDy,
  dsAliBigModelExtract
}